import Clarity from '@microsoft/clarity';
import { useQuery } from '@tanstack/react-query';

import { QueryKeys } from '@/app/constants/queryKeys';
import { useAuth } from '@/app/hooks/useAuth';
import { Analytics } from '@/app/libs/analytics/instance';
import { Sentry } from '@/app/libs/sentry/instance';

export const useUserTraffic = () => {
  const { user } = useAuth();

  return useQuery({
    enabled: !!user,
    gcTime: Infinity,
    staleTime: Infinity,
    queryKey: [QueryKeys.currentIp],
    queryFn: async () => {
      if (!user) return '';

      const response = await fetch('https://api.ipify.org');
      const ip = await response.text();

      try {
        Clarity.identify(user.email, user.username, 'sgp', user.name);
        Analytics.set({ user_properties: { name: user.name, email: user.email.split('@')[0] } });
        Sentry.setUser({ ip_address: ip, email: user.email, id: user.email, username: user.name });
      } catch {
        return ip;
      }

      return ip;
    },
  });
};
